import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        setTimeout(()=>{
            // "nearest" scrolls only the minimum needed to reveal the element, and
            // does nothing when it is already fully in view.
            this.element.scrollIntoView({ block: "nearest" });
        }, 100)
    }
}
